const tabber = {
    init() {
        let tabberAnchors = document.querySelectorAll('.tabber-section .nav a');

        tabberAnchors.forEach(function(tabberAnchor) {
            const tabID = tabberAnchor.getAttribute('data-tab-id');
            const targetTab = document.querySelector('#' + tabID);

            tabberAnchor.onclick = function(e){
                e.preventDefault();
                const otherTabAnchors = tabberAnchor.parentNode.querySelectorAll('a');
                const otherTabs = targetTab.parentNode.querySelectorAll('.tab-box');

                otherTabAnchors.forEach(function (otherTabAnchors) {
                    otherTabAnchors.classList.remove('active');
                });

                otherTabs.forEach(function (otherTab) {
                    otherTab.classList.remove('active');
                });

                tabberAnchor.classList.add('active');
                targetTab.classList.add('active');
            };
        });
    }
}

tabber.init();